/*
 * @ProjectName: Union Service
 * @FileName:
 * @PackageName:
 * @Author: Zhanglei
 * @Date: 2020-08-20 15:41:35
 * @LastEditTime: 2020-08-20 18:36:06
 * @LastEditors: Zhanglei
 * @Description:
 * @FilePath: /desktop/src/store/modules/unit.js
 * @copyright(c) 2017-2020 BMW Brilliance Automotive Co., Ltd.
 */
import {
  getTableHeaderApi,
  getTableDataApi,
  getChangeDataApi,
  deleteDataApi,
  postDataApi,
  getUserApi,
  getUserItemApi
} from "@/service/unitService";

const unit = {
  state: {},
  mutations: {},
  getters: {},
  actions: {
    getUnitHeader(store, id) {
      return new Promise((resolve, reject) => {
        getTableHeaderApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUnitData(store, idInfo) {
      return new Promise((resolve, reject) => {
        getTableDataApi(idInfo)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    getChangeUnitData(store, data) {
      return new Promise((resolve, reject) => {
        getChangeDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    deleteUnitData(store, id) {
      return new Promise((resolve, reject) => {
        deleteDataApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    postUnitData(store, data) {
      return new Promise((resolve, reject) => {
        postDataApi(data)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUnitUser(store, id) {
      return new Promise((resolve, reject) => {
        getUserApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    getUnitUserItem(store, id) {
      return new Promise((resolve, reject) => {
        getUserItemApi(id)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default unit;



// WEBPACK FOOTER //
// ./src/store/modules/unit.js